"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlags = getFlags;
exports.fetchFlags = fetchFlags;
const tslib_1 = require("tslib");
const environment_1 = require("../utils/environment");
const cookie_1 = require("../utils/cookie");
const store_locale_1 = require("../utils/store-locale");
const webview_1 = require("../webview");
const constants_1 = require("./constants");
function getBaseUrl() {
    if (environment_1.isStaging) {
        return constants_1.FlagrBaseUrl.STAGING;
    }
    if (environment_1.isProduction) {
        return constants_1.FlagrBaseUrl.PRODUCTION;
    }
    // local environment
    return constants_1.FlagrBaseUrl.STAGING;
}
function getEntityContext(storeCode) {
    const { userId, deviceId, ggId } = (0, cookie_1.getCookies)();
    return {
        userId: Number(userId !== null && userId !== void 0 ? userId : -1),
        ggId,
        deviceId,
        storeCode,
        flavour: (0, webview_1.isInWebView)() ? 'app' : 'web',
    };
}
let fetchedFlags = new Map();
function getFlags() {
    return fetchedFlags;
}
function fetchFlags() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { storeCode } = (0, store_locale_1.getStoreLocale)();
        const baseUrl = getBaseUrl();
        const entityContext = getEntityContext(storeCode);
        try {
            const res = yield fetch(`${baseUrl}/evaluation/batch`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    flagKeys: [constants_1.FeatureFlagKey.ZENDESK],
                    entities: [
                        {
                            entityID: entityContext.deviceId,
                            entityContext,
                        },
                    ],
                }),
            });
            if (res.ok) {
                const response = yield res.json();
                const flags = response.evaluationResults;
                fetchedFlags = new Map(flags.map((flag) => [flag.flagKey, flag]));
            }
            else {
                throw new Error(`Could not fetch feature flags: [${res.status}] ${res.statusText}`);
            }
        }
        catch (err) {
            console.warn(err);
        }
    });
}
//# sourceMappingURL=fetch-flags.js.map